import { Component } from 'react';
import './slash.css';

//TODO: delete <<
import {}
  from '../fx/boss';

//TODO: delete >>


class Slash extends Component {

  //TODO: delete <<
  componentWillMount = () => {
  };

  //TODO: delete >>

  render() {

    return (
      null
    );
  };
}

export default Slash;


// WEBPACK FOOTER //
// ./src/containers/Slash.js